export default "__VITE_ASSET__B2F8UIjY__"